import { connect } from 'react-redux'
import requestMoveCard from '../../sagas/requestMoveCard'
import moveCardSelector from './moveCardSelector'
import MoveCard from './MoveCard'

export default connect(
  moveCardSelector,
  {
    requestMoveCard
  }
)(MoveCard)

